import React, { useEffect, useState } from 'react'
import { apiGet, apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import OInputField from 'components/reusable/OInputField'
import { useTranslation } from 'react-i18next'
import formValidation from 'utils/formValidation'
import OSelect from 'components/reusable/OSelect'

const SubCategoryEdit = ({ allSubCategory, currentItem, handleEdit }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const [categoryList, setCategoryList] = useState([])
  const [cat, setCat] = useState(currentItem?.propertyTypeId)
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      name: currentItem?.name,
      nameAr: currentItem?.nameAr,
      propertyTypeId: currentItem?.propertyTypeId,
      shortName: currentItem?.shortName
    }
  })

  const onSubmit = async data => {
    try {
      const path = apiPath.editPropertyCategory + '/' + currentItem._id
      const result = await apiPut(path, { ...data })
      if (result.data.success) {
        allSubCategory()
        handleEdit(false)
        notification.success(result?.data.message)
      } else {
        notification.error(result?.data.message)
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error)
      notification.error(error.message)
    }
  }

  const allCategory = async payload => {
    try {
      const path = apiPath.listPropertyType
      const result = await apiGet(path, payload)
      if (result?.data?.success) {
        const response = result?.data?.results
        const categoriesList = response?.map(item => {
          return { key: item?.name, value: item?._id, keyAr: item?.nameAr }
        })
        setCategoryList(categoriesList)
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }

  useEffect(() => {
    allCategory()
  }, [])

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>
                  {t('EDIT_PROPERTY_CATEGORY')}
                </h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => handleEdit(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl '>×</span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid sm:grid-cols-2'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OSelect
                      wrapperClassName='relative z-0 mb-6 w-full group'
                      name='propertyTypeId'
                      inputLabel={
                        <>
                          {t('O_PROPERTY_TYPE')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='select'
                      value={cat}
                      onChange={e => setCat(e.target.value)}
                      options={categoryList}
                      selected={currentItem?.propertyTypeId}
                      defaultValue={t('O_SELECT_PROPERTY_TYPE')}
                      register={register(
                        'propertyTypeId',
                        formValidation.propertyTypeId
                      )}
                      errors={errors}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='shortName'
                      inputLabel={
                        <>
                          {t('O_SHORT_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      register={register('shortName', formValidation.shortName)}
                      errors={errors}
                      // onChange={(event) => {
                      //   event.target.value = event.target.value.toUpperCase();
                      // }}
                      value={watch('shortName')?.toUpperCase()}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='name'
                      inputLabel={
                        <>
                          {t('O_PROPERTY_CATEGORY')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      autoFocus
                      register={register('name', formValidation.property)}
                      errors={errors}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='nameAr'
                      inputLabel={
                        <>
                          {t('O_PROPERTY_CATEGORY') + t('O_ARABIC')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      maxLength={15}
                      register={register('nameAr', formValidation.propertyAr)}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => handleEdit(false)}
                >
                  Back
                </button>
                <button
                  className='bg-[#8FC150] text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                  type='submit'
                  onClick={handleSubmit(onSubmit)}

                  // onClick={(e) => handleSubmit(e)}
                >
                  {t('SAVE')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default SubCategoryEdit
